import { Injectable, signal } from '@angular/core';
import { AccountServiceProxy, IsTenantAvailableInput, IsTenantAvailableOutput } from '@shared/service-proxies/service-proxies';
import { Observable } from 'rxjs';
import { TenantName } from '@shared/constants/tenant-name.enum';

@Injectable({
    providedIn: 'root',
})
export class MultiTenancyService {
    readonly hasSurveysEnabled = signal<boolean>(this.getTenancyName() !== TenantName.caresWell).asReadonly();

    constructor(private accountServiceProxy: AccountServiceProxy) {}

    getTenantId(): Observable<IsTenantAvailableOutput> {
        const tenancyName = this.getTenancyName();
        return this.accountServiceProxy.isTenantAvailable(
            new IsTenantAvailableInput({
                tenancyName,
            }),
        );
    }

    getTenancyName(): string {
        return window.location.hostname.split('.')[0];
    }
}
